import api from '../../utils/apiService/apiService';
import { UserFormData } from './appModel';

const appApi = {
  getUser: () => {
    const request = api.get('users/me');
    return request;
  },
  signUp: (formData: UserFormData) => {
    const request = api.post('enrollment/signup', formData);
    return request;
  },
};

export default appApi;
